<template>
    <div id="details">
        
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="record.fields.TITLE"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="800px"
 
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <v-card class="mx-auto my-12">
        <v-container>
          <v-row>
            <v-col class="md4 lg4 xl4 sm12">
              <div class="text-center">
                <v-img
                  height="250"
                  contain
                  :src="record.fields.IMAGE"
                  :alt="record.fields.TITLE"
                ></v-img>
                <!-- <iframe
                  title="Training Video"
                  alt="Training Video"
                  height="250"
                  class="mt-6 mb-6"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  :src="record.fields.VIDEOSRC"
                  frameborder="0"
                ></iframe>
                <iframe
                  alt="Google Map"
                  title="Google Map"
                  :src="record.fields.GMAP"
                  frameborder="0"
                  style="border:0;"
                  allowfullscreen
                  aria-hidden="false"
                  tabindex="0"
                ></iframe> -->
              </div>
            </v-col>
            <v-col>
              <h1 class="font-weight-black">{{ record.fields.TITLE }}</h1>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    aria-label="Rate out of 5 stars"
                    :value="parseFloat(record.fields.RATING)"
                    half-increments
                    readonly
                  >
                    <template v-slot:item="props">
                      <v-icon aria-label="star" color="amber" size="20">{{
                        props.isFilled ? 'mdi-star' : 'mdi-star-outline'
                      }}</v-icon>
                    </template>
                  </v-rating>

                  <div class="black--text ml-4">
                    {{ record.fields.RATING }} out of 5 &nbsp;&nbsp;
                    <span class="number-of-reviews"
                      >({{ record.fields.REVIEWS }} reviews)</span
                    >
                  </div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  {{ record.fields.PRICE }}

                  <v-chip class="ml-4">{{ record.fields.TYPE }}</v-chip>
                </div>

                <p>
                  {{ record.fields.DESCRIPTION }}
                </p>

                <p><b>Languages: </b>{{ record.fields.LANGUAGE }}</p>
                <p>
                  <b>Accessibility: </b>
                  {{ record.fields.A11Y }}
                </p>
                <p>
                  <b>Phone Number: </b>
                  {{ record.fields.PHONE }}
                </p>
                <p>
                  <b>Address: </b>
                  {{ record.fields.ADDRESS }}
                </p>
                <p>
                  <b>Email: </b>
                  {{ record.fields.EMAIL }}
                </p>

                <p>
                  <b>Hours of Operation: </b>
                  {{ record.fields.HOURS }}
                </p>

                <div class="mt-6">
                  <v-btn fab aria-label="Save as pdf button">
                    <v-icon @click="pdf()" aria-label="pdf icon">
                      mdi-file-pdf
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    @click="print()"
                    class="ml-6 mr-6"
                    aria-label="Print button"
                  >
                    <v-icon>
                      mdi-printer
                    </v-icon>
                  </v-btn>
                  <v-btn fab aria-label="Email button">
                    <a
                      aria-label="mailto link"
                      :href="
                        'mailto:' +
                          record.fields.EMAIL +
                          '?cc=&bcc=&subject=Question%20about%20' +
                          record.fields.TITLE +
                          '&body=Type%20your%20question%20here'
                      "
                    >
                      <v-icon>
                        mdi-email
                      </v-icon>
                    </a>
                  </v-btn>
                </div>
              </v-card-text>

              <v-card-actions class="mb-12">
                <v-row>
                  <v-col>
                    <v-btn
                      class="pl-4 pr-6"
                      x-large
                      :disabled="isDisabled"
                      color="amber darken-1"
                      @click="addToCart(record)"
                      aria-label="Add to cart button"
                    >
                      <img
                        class="pl-3 pr-3"
                        src="@/assets/icons/add_shopping_cart.svg"
                        alt="Add to shopping cart icon"
                      />
                      Add to your cart</v-btn
                    >
                  </v-col>
                  <v-col>
                    <v-btn
                      class="pl-12 pr-12"
                      @click="enroll(record.fields.URL)"
                      x-large
                      color="primary"
                      aria-label="Enroll button"
                    >
                      <v-icon class="pr-3"
                        >mdi-checkbox-marked-circle-outline</v-icon
                      >
                      Enroll
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="pl-12 pr-12"
                      @click="notInterested(record)"
                      :disabled="isNotInterested"
                      x-large
                      outlined=""
                      aria-label="Not Interested button"
                    >
                      <v-icon class="pr-3">mdi-comment-remove-outline</v-icon>
                      Not Interested
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
        </section>
    </vue-html2pdf>
    
      <v-card class="mx-auto my-12">
        <v-container>
          <v-row>
            <v-col class="md4 lg4 xl4 sm12">
              <div class="text-center">
                <v-img
                  height="250"
                  contain
                  :src="record.fields.IMAGE"
                  :alt="record.fields.TITLE"
                ></v-img>
                <iframe
                  title="Training Video"
                  alt="Training Video"
                  height="250"
                  class="mt-6 mb-6"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  :src="record.fields.VIDEOSRC"
                  frameborder="0"
                ></iframe>
                <iframe
                  alt="Google Map"
                  title="Google Map"
                  :src="record.fields.GMAP"
                  frameborder="0"
                  style="border:0;"
                  allowfullscreen
                  aria-hidden="false"
                  tabindex="0"
                ></iframe>
              </div>
            </v-col>
            <v-col>
              <h1 class="font-weight-black">{{ record.fields.TITLE }}</h1>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    aria-label="Rate out of 5 stars"
                    :value="parseFloat(record.fields.RATING)"
                    half-increments
                    readonly
                  >
                    <template v-slot:item="props">
                      <v-icon aria-label="star" color="amber" size="20">{{
                        props.isFilled ? 'mdi-star' : 'mdi-star-outline'
                      }}</v-icon>
                    </template>
                  </v-rating>

                  <div class="black--text ml-4">
                    {{ record.fields.RATING }} out of 5 &nbsp;&nbsp;
                    <span class="number-of-reviews"
                      >({{ record.fields.REVIEWS }} reviews)</span
                    >
                  </div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  {{ record.fields.PRICE }}

                  <v-chip class="ml-4">{{ record.fields.TYPE }}</v-chip>
                </div>

                <p>
                  {{ record.fields.DESCRIPTION }}
                </p>

                <p><b>Languages: </b>{{ record.fields.LANGUAGE }}</p>
                <p>
                  <b>Accessibility: </b>
                  {{ record.fields.A11Y }}
                </p>
                <p>
                  <b>Phone Number: </b>
                  {{ record.fields.PHONE }}
                </p>
                <p>
                  <b>Address: </b>
                  {{ record.fields.ADDRESS }}
                </p>
                <p>
                  <b>Email: </b>
                  {{ record.fields.EMAIL }}
                </p>

                <p>
                  <b>Hours of Operation: </b>
                  {{ record.fields.HOURS }}
                </p>

                <div class="mt-6">
                  <v-btn fab aria-label="Save as pdf button">
                    <v-icon @click="pdf()" aria-label="pdf icon">
                      mdi-file-pdf
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    @click="print()"
                    class="ml-6 mr-6"
                    aria-label="Print button"
                  >
                    <v-icon>
                      mdi-printer
                    </v-icon>
                  </v-btn>
                  <v-btn fab aria-label="Email button">
                    <a
                      aria-label="mailto link"
                      :href="
                        'mailto:' +
                          record.fields.EMAIL +
                          '?cc=&bcc=&subject=Question%20about%20' +
                          record.fields.TITLE +
                          '&body=Type%20your%20question%20here'
                      "
                    >
                      <v-icon>
                        mdi-email
                      </v-icon>
                    </a>
                  </v-btn>
                </div>
              </v-card-text>

              <v-card-actions class="mb-12">
                <v-row>
                  <v-col>
                    <v-btn
                      class="pl-4 pr-6"
                      x-large
                      :disabled="isDisabled"
                      color="amber darken-1"
                      @click="addToCart(record)"
                      aria-label="Add to cart button"
                    >
                      <img
                        class="pl-3 pr-3"
                        src="@/assets/icons/add_shopping_cart.svg"
                        alt="Add to shopping cart icon"
                      />
                      Add to your cart</v-btn
                    >
                  </v-col>
                  <v-col>
                    <v-btn
                      class="pl-12 pr-12"
                      @click="enroll(record.fields.URL)"
                      x-large
                      color="primary"
                      aria-label="Enroll button"
                    >
                      <v-icon class="pr-3"
                        >mdi-checkbox-marked-circle-outline</v-icon
                      >
                      Enroll
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="pl-12 pr-12"
                      @click="notInterested(record)"
                      :disabled="isNotInterested"
                      x-large
                      outlined=""
                      aria-label="Not Interested button"
                    >
                      <v-icon class="pr-3">mdi-comment-remove-outline</v-icon>
                      Not Interested
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <p class="section-heading mt-12 mb-12 ml-12 font-weight-light">Reviews</p>
      <Reviews
        class="mb-6"
        v-for="n in allReviews.slice(0, 3)"
        :key="n.id"
        :reviewData="n"
      />

      <v-row class="justify-center">
        <router-link
          :to="{
            name: 'ReviewsAll',
            params: { allReviews: allReviews },
            query: { record: record.id },
          }"
          @click="this.$ga.event({
  eventCategory: 'details',
  eventAction: 'route-to-ReviewsAll-page',
  eventLabel: 'see-all-reviews-button'
})"
        >
          <v-btn class="mt-12 mb-12" outlined aria-label="See All Reviews"
            >See All Reviews
            <v-icon class="pl-4" title="see all reviews">mdi-dots-horizontal</v-icon>
          </v-btn>
        </router-link>
      </v-row>

      <div class="bottom-recs">
        <v-row class="mb-12">
          <p class="section-heading mt-12 mb-12 ml-12 font-weight-light">
            People also liked
          </p>
          <SlideGroup class="pl-12 pr-12" :slideData="alsoLiked" />
        </v-row>
        <v-row class="pb-12">
          <p class="section-heading mt-12 mb-12 ml-12 font-weight-light">
            Similar to this item
          </p>
          <SlideGroup class="pl-12 pr-12" :slideData="similarTo" />
        </v-row>
      </div>
    </div>
</template>

<script>
import Reviews from '../components/Reviews';
import axios from 'axios';
import SlideGroup from '../components/SlideGroup';
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'Details',
  components: {
    Reviews,
    SlideGroup,
    VueHtml2pdf    
  },
  data() {
    return {
      isNotInterested: false,
      allReviews: [],
      isDisabled: false,
      selection: null,
      loading: null,
      record: {
        id: "",
        fields: {
          A11Y: "",
          ADDRESS: "",
          DESCRIPTION: "",
          EMAIL: "",
          GMAP: "",
          HOURS: "",
          IMAGE: "",
          ITEM_ID: "",
          LANGUAGE: "",
          PHONE: "",
          PRICE: "",
          RATING: "",
          RECORD_ID: "",
          REVIEWS: "",
          TITLE: "",
          TYPE: "",
          URL: "",
          VIDEO: "",
          VIDEOSRC: "",
          ZIPCODE: "",
        }
      },
      alsoLiked: [],
      similarTo: [],
    };
  },
  watch: {
    $route() {
      location.reload();
      this.getAlsoLiked();
      this.getSimilarTo();
    },
  },
  mounted() {
    this.getAlsoLiked();
    this.getSimilarTo();
    this.retrieveRecord(this.$route.query.record);
    this.getAllReviews();
    // gmap iframe google logo, image must have alternative text
    // can't select iframe elements
    // setTimeout(function() {
    //   document
    //     .querySelector('img[style*="width: 52px"]')
    //     .setAttribute('alt', 'hello');
    // }, 1000);
  },
  // created() {},
  methods: {
    notInterested() {
      // console.log(r);
      this.isNotInterested = true;
      // TODO store not interested, for this given user
      // display under refine
    },
    retrieveRecord(id) {
      axios
        .get(`https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data/${id}`, {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
          },
        })
        .then(
          (r) => {
            // console.log(r.data);
            this.record = r.data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getAlsoLiked() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?view=Grid%20view',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            const liked = r.data.records
              .sort(() => 0.5 - Math.random())
              .slice(0, 6);
            this.alsoLiked = liked;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getSimilarTo() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?view=Grid%20view',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            const similar = r.data.records
              .sort(() => 0.5 - Math.random())
              .slice(0, 6);
            this.similarTo = similar;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getAllReviews() {
      axios
        .get(
          `https://api.airtable.com/v0/appv5BP8mMWk2bJTA/Table%201?view=Grid%20view`,
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            this.allReviews = r.data.records;
            // console.log(this.allReviews);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    addToCart(t) {
      this.$store.dispatch('addCartItem', t);

      window.aa('AddToCartFromDetails', {
        userToken: 'user-1928fh19fh38',
        index: 'Airtable',
        eventName: 'add_to_cart',
        objectIDs: ['objectID1', 'objectID2'],
      });

      this.isDisabled = true;
    },
    enroll(url) {
      window.open(`${url}`,'_blank','noopener');
    },
    print() {
      window.print();
    },
    pdf() {
      this.$refs.html2Pdf.generatePdf()
    },
  },
};
</script>

<style scoped>
.section-heading {
  font-size: 2rem;
  font-weight: bold !important;
}

.text-center {
  display: flex;
  flex-direction: column;
}

.bottom-recs {
  background-color: #f1f1f1;
}

.number-of-reviews {
  font-size: 0.8rem;
}
</style>
